import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'
import useCanonical from '~/hooks/useCanonical'
import useAtmosphere from '../hooks/useAtmosphere'
import useRouter from '../hooks/useRouter'
import getValidRedirectParam from '../utils/getValidRedirectParam'
import {AUTH_DIALOG_WIDTH} from './AuthenticationDialog'
import GenericAuthentication, {} from './GenericAuthentication'
import TeamInvitationWrapper from './TeamInvitationWrapper'

const CopyBlock = styled('div')({
  marginBottom: 48,
  width: 'calc(100vw - 16px)',
  // must be no wider than the auth popup width to keep it looking clean
  maxWidth: AUTH_DIALOG_WIDTH,
  textAlign: 'center'
})





const AuthenticationPage = (props) => {
  const {history} = useRouter()
  const {page} = props
  const atmosphere = useAtmosphere()
  const {authObj} = atmosphere
  useCanonical(page)
  if (authObj) {
    const nextUrl = getValidRedirectParam() || '/meetings'
    // always replace otherwise they could get stuck in a back-button loop
    setTimeout(() => history.replace(nextUrl))
    return null
  }
  const goToPage = (page, search) => {
    const url = search ? `/${page}${search}` : `/${page}`
    history.push(url)
  }
  return (
    _jsxs(TeamInvitationWrapper, { children: [
      _jsxs(CopyBlock, { children: [
        _jsxs('h1', { children: ["Better Meetings, "
            , _jsx('br', {} ), "Less Effort"

        ]})
        , _jsx('p', { children: "92% of users agreed that Parabol improves the efficiency of their meetings."           })
      ]})
      , _jsx(GenericAuthentication, { page: page, goToPage: goToPage,} )
    ]})
  )
}
export default AuthenticationPage
